import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchMyReliability = createAsyncThunk("fetchMyReliability", async () => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`analytics/myreliability`, config);

	return response.data;
});

const myReliabilitySlice = createSlice({
	name: "myReliabilitySlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetMyReliabilitySliceState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMyReliability.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMyReliability.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchMyReliability.rejected, (state, action) => {
			state.isLoading = false;
			state.data = null;
			state.error = action.payload;
		});
	},
});

export const { resetMyReliabilitySliceState } = myReliabilitySlice.actions;
export default myReliabilitySlice.reducer;
